// Reservations Reducer

import { initializeState } from '../../../utilities/storageUtils';
import reservationsActionTypes from './reservations.types';

const INITIAL_STATE = {
  reservationList: [],
  upcomingReservationList: [],
  pastReservationList: [],
  canceledReservationList: [],
  isLoading: false,
  isInitialLoading: false,
  requestFailed: false,
  requestHasFinished: false,
  errorMessage: null,
  errorType: '',
  status: '',
  lastNameFindReservationById: '',
  reservationKeyFindReservationById: { key: '', reservationId: '' }
};

/**
 *
 * IMPORTANT!!!
 * The validation of reservation.isCabana is required to avoid showing cabanas reservations
 * this was implemented by story 30448, this is just a FE fix, the fix needs to be completed
 * on the BE and will be implemented on another story
 */
export function reservationListHandler(reservationData) {
  const reservedReservations = reservationData['RESERVED'] ? reservationData['RESERVED'] : [];
  const changedReservations = reservationData['CHANGED'] ? reservationData['CHANGED'] : [];
  const noShowReservations = reservationData['NO_SHOW'] ? reservationData['NO_SHOW'] : [];
  const checkedOutReservations = reservationData['CHECKEDOUT'] ? reservationData['CHECKEDOUT'] : [];
  const filteredReservations = {
    upcomingReservationList: [...reservedReservations, ...changedReservations] ?? [],
    pastReservationList: [...noShowReservations, ...checkedOutReservations] ?? [],
    canceledReservationList: reservationData['CANCELED'] ?? []
  };
  return filteredReservations;
}

const reservationsReducer = (state, action) => {
  state = initializeState(state, INITIAL_STATE);

  // Get Book information reducers
  switch (action.type) {
    case reservationsActionTypes.SET_RESERVATION_LAST_NAME_FIND_BY_ID:
      return {
        ...state,
        lastNameFindReservationById: action.lastName
      };

    case reservationsActionTypes.CREATE_RESERVATION_LOADING:
      return {
        ...state,
        reservationList: [...state.reservationList],
        upcomingReservationList: [...state.upcomingReservationList],
        pastReservationList: [...state.pastReservationList],
        canceledReservationList: [...state.canceledReservationList],
        isLoading: action.isLoading
      };
    case reservationsActionTypes.CREATE_RESERVATION_ERROR:
      return {
        ...state,
        reservationList: [...state.reservationList],
        upcomingReservationList: [...state.upcomingReservationList],
        pastReservationList: [...state.pastReservationList],
        canceledReservationList: [...state.canceledReservationList],
        errorMessage: action.errorMessage,
        errorType: action.errorType
      };

    // Reservation item request succeded
    case reservationsActionTypes.GET_RESERVATION_INFO_SUCCESS:
      return {
        ...state,
        reservationList: action.reservationList,
        upcomingReservationList: action.upcomingReservationList,
        pastReservationList: action.pastReservationList,
        canceledReservationList: action.canceledReservationList,
        requestFailed: false,
        isLoading: false,
        isInitialLoading: false,
        errorMessage: null
      };
    // The request is currently running
    case reservationsActionTypes.GET_RESERVATION_INFO_LOADING:
      return {
        ...state,
        isLoading: action.isLoading
      };
    // Reservation item request failed
    case reservationsActionTypes.GET_RESERVATION_INFO_ERROR:
      return {
        ...state,
        reservationList: action.reservationList,
        upcomingReservationList: [],
        pastReservationList: [],
        canceledReservationList: [],
        requestFailed: action.requestFailed,
        errorMessage: action.errorMessage,
        isLoading: false,
        isInitialLoading: false
      };
    // Reservation item request finished
    case reservationsActionTypes.GET_RESERVATION_INFO_FINISH:
      const getValidValue = (value, key) => (value !== undefined ? value : state[key]);

      const newIsLoadingValue = getValidValue(action.isLoading, 'isLoading');
      const newErrorMessageValue = getValidValue(action.errorMessage, 'errorMessage');
      const newRequestFailedValue = getValidValue(action.requestFailed, 'requestFailed');

      return {
        ...state,
        requestHasFinished: action.requestHasFinished,
        isLoading: newIsLoadingValue,
        errorMessage: newErrorMessageValue,
        requestFailed: newRequestFailedValue
      };

    // Action to clear the errors
    case reservationsActionTypes.CLEAR_RESERVATION_ERROR:
      return {
        ...state,
        requestFailed: false,
        errorMessage: null,
        errorType: ''
      };

    // Action to set initial loading.
    case reservationsActionTypes.GET_RESERVATION_INITIAL_INFO_LOADING:
      return {
        ...state,
        isInitialLoading: action.isInitialLoading
      };

    case reservationsActionTypes.SET_RESERVATION_KEY_FIND_RESERVATION_BY_ID:
      return {
        ...state,
        reservationKeyFindReservationById: action.reservationIdKey
      };

    default:
      return state;
  }
};

export default reservationsReducer;
